import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.dokumente';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumenteEffects {

    Dokumente$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DOKUMENTE),
        mergeMap((x: ac.GetDokumenteAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDokumente().pipe(
                map((result: any) => {
                    return new ac.GetDokumenteErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDokumenteFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentQueryService);
        }
        return this.service;
    }
}
